import { render, staticRenderFns } from "./TruformeLanding.vue?vue&type=template&id=32439e80&scoped=true"
import script from "./TruformeLanding.vue?vue&type=script&lang=ts"
export * from "./TruformeLanding.vue?vue&type=script&lang=ts"
import style0 from "./TruformeLanding.vue?vue&type=style&index=0&id=32439e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32439e80",
  null
  
)

export default component.exports